import React, { useEffect, useRef, useState } from "react";
import img1 from "../../assets/images/khojgraphics/Moving_graphic_3.gif";
import img2 from "../../assets/images/khojgraphics/Work with us.gif";
import { Button, Col, Row, Form } from "react-bootstrap";
import { fetchCityData } from "../../redux/actions/citiesAction";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import { fetchDesignation } from "../../redux/actions/designationAction";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import { customStyles } from "../../selectStyles";


function Reviewworkwitus(props) {
	const [viewPortEntered, setViewPortEntered] = useState(false);
	const dispatch = useDispatch();
	const [display, setDisplay] = useState(false);
	const fileInputRef = useRef(null);

	const onVWEnter = () => {
		setViewPortEntered(true);
	};

	const [fullName, setFullName] = useState("");
	const [email, setEmail] = useState("");
	const [contact, setContact] = useState("");
	const [linkedInProfile, setLinkedInProfile] = useState("");
	const [Reason, setReason] = useState("");
	const [resumeFile, setResumeFile] = useState(null);

	const uploadResume = async () => {
		console.log("========>");
		setDisplay(true);

		if (
			fullName === "" ||
			email === "" ||
			contact === "" ||
			designationSearch === "" ||
			cityListSearch === "" ||
			Reason === ""
		) {
			toast.error("Please fill all the required fields");
		} else {

			const formData = new FormData();
			formData.append("Name", fullName);
			formData.append("Email", email);
			formData.append("Phone", contact);
			formData.append("Designation", designationSearch);
			formData.append("Attachment", resumeFile);
			formData.append("Location", cityListSearch);
			formData.append("Description", Reason);
			formData.append("LinkedIn", linkedInProfile);
			try {
				const res = await axios.post("/Feature/AddWorkWithUsData", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});
				console.log("res", res);
				toast.success(res.data.message);
				setFullName("");
				setEmail("");
				setContact("");
				setLinkedInProfile("");
				setReason("");
				setResumeFile("");
				setDisplay(false);
				setDesignationSearch(null);
				setcityListSearch(null);
				if (fileInputRef.current) {
					fileInputRef.current.value = "";
				}
			} catch (error) {
				if (error.response && error.response.status === 404) {
					toast.error(error.response.data.message);
				} else if (error.response && error.response.status === 413) {
					toast.error(error.response.data.message);
				} else {
					toast.error(error.response?.data?.message || "Payload Too Large");
				}
			}
		}

	};



	const [cityListSearch, setcityListSearch] = useState("");
	const { cityList, selectedcityId } = useSelector((state) => state.cities);

	useEffect(() => {
		dispatch(fetchCityData());
	}, [dispatch]);
	const handleCityInputChange = (inputValue) => {
		dispatch(fetchCityData(inputValue));
	};

	const handleCitySelect = (selectedOption) => {
		if (selectedOption) {
			setcityListSearch(selectedOption.value);
		} else {
			setcityListSearch(null);

		}
	};

	// Designation

	const [designationSearch, setDesignationSearch] = useState("");
	const { designationList, selectedDesignationId } = useSelector(
		(state) => state.designation
	);
	useEffect(() => {
		dispatch(fetchDesignation());
	}, [dispatch]);

	const handleDesignation = (selectedOption) => {
		if (selectedOption) {
			// dispatch(selectDesignation(selectedOption.value));
			setDesignationSearch(selectedOption.value);
		} else {
			setDesignationSearch(null);
		}
	};

	// const handleCityChange = (selectedOption) => {
	// 	// setCityData(selectedOption.value)
	// };

	// const [resumeFile, setResumeFile] = useState(null);
	const [resumeError, setResumeError] = useState("");

	return (
		<section className="inner-review-section inner-review-section-mobile">
			<div className="container">
				<div className="wd-review-job contentbox1 page-text stc">
					<h3>Work with Us at People Labs</h3>
					<p className="mb-2">
						At People Labs, we’re shaping a future-ready workforce and driving organizational success. We value our talented team and are always looking for passionate individuals eager to contribute to the evolution of training, consulting, and recruitment.Whether you are an experienced recruiter or an emerging talent, we invite you to explore opportunities to join our esteemed team.
					</p>
				</div>

				<div className="row" style={{ paddingBottom: "60px" }}>
					<div className="col-lg-6 col-md-12">
						<div className="wd-review-job thumb2 widget-counter stc me-4 mt-5 about-mobile">
							<div className="">
								<img src={img2} alt="images" />
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-12 wow fadeInRight">
						<div className="wd-review-job contentbox1 page-text stc">
							<h1>Why Choose Us?</h1>
							<ul className="work-with-content">
								<li className="f-16"><span className="f-700">Make an Impact:</span> Empower individuals, transform organizations, and shape the future of work.
								</li>
								<li className="f-16"><span className="f-700">Collaborative Culture:</span> Work in a diverse and inclusive environment where every idea matters.

								</li>
								<li className="f-16"><span className="f-700">Continuous Growth:</span> Access training, mentorship, and opportunities to develop professionally.
								</li>
								<li className="f-16"><span className="f-700">Flexibility & Autonomy:</span> Thrive in a space that encourages individuality and work-life balance.

								</li>
							</ul>
						</div>
					</div>

				</div>
				<div className="registration-form wd-review-job page-text">
					<h3>Registration Form</h3>
					<section className="account-section pt-1">
						<div className="profile-setting-form">
							<Row>
								<Col md={6}>
									<div className="post-form-group mb-3">
										<label htmlFor="category">
											Full name : <span className="text-red">*</span>
										</label>
										<input
											type="email"
											id="tag"
											placeholder="Enter full name"
											onChange={(e) => setFullName(e.target.value)}
											value={fullName}
											className="Normal-Input-Fill"
										/>
										{display && !fullName ? (
											<span className="error_msg_lbl">
												Enter full name{" "}
											</span>
										) : null}
									</div>

								</Col>
								<Col md={6}>
									<div className="post-form-group text-transform-email post-form-group-mob">
										<label>
											Email address : <span className="text-red">*</span>
										</label>
										<input
											type="email"
											placeholder="Enter email"
											value={email}
											onChange={(e) => setEmail(e.target.value)}
											id="email"
											name="email"
											className="Normal-Input-Fill"
										// invalid={displays && firstName === ""}
										/>
										{display && !email ? (
											<span className="error_msg_lbl">
												Enter email{" "}
											</span>
										) : null}
									</div>
								</Col>
								<Col md={6}>
									<div className="post-form-group mb-3">
										<label>
											Phone number : <span className="text-red">*</span>
										</label>
										<input
											type="number"
											placeholder="Enter phone number"
											value={contact}
											onChange={(e) => setContact(e.target.value)}
											id="email"
											name="contact"

											className="Normal-Input-Fill"
										// invalid={displays && lastName === ""}
										/>
										{display && !contact ? (
											<span className="error_msg_lbl">
												Enter phone number{" "}
											</span>
										) : null}
									</div>
								</Col>

								<Col md={6}>
									<div className=" post-form-group  post-form-group-mob">
										<label htmlFor="about">
											City : <span className="text-danger"> *</span>
										</label>

										<ReactSelect
											options={cityList}
											onChange={handleCitySelect}
											value={
												cityList.find(
													(option) => option.value === cityListSearch
												) || null
											}
											placeholder="Search & select city"
											onInputChange={handleCityInputChange}
											classNamePrefix="react-select"
											className="form-control Dark-Input-from-group"
											isClearable
											styles={customStyles}
										/>
										{display && !cityListSearch ? (
											<span className="error_msg_lbl">
												Select city{" "}
											</span>
										) : null}
									</div>
								</Col>



								<Col md={6}>
									<div className=" post-form-group mb-3">
										<label htmlFor="about">
											Designation : <span className="text-danger"> *</span>
										</label>

										<ReactSelect
											options={designationList}
											onChange={handleDesignation}
											value={
												designationList.find(
													(option) => option.value === designationSearch
												) || null
											}
											placeholder="Search & select designation"
											// onInputChange={handleCityInputChange}
											classNamePrefix="react-select"
											className="form-control Dark-Input-from-group"
											styles={customStyles}
											isClearable
										/>
										{display && !designationSearch ? (
											<span className="error_msg_lbl">
												Select designation{" "}
											</span>
										) : null}
									</div>
								</Col>
								{/* <Col md={6}>
									<div className="post-form-group post-form-group-mob">
										<label>
											Upload Resume : <span className="text-red">*</span><span className="text-red f-500 ms-2">Can upload only 5MB file</span>
										</label>
										<input
											type="file"
											id="resumeUpload"
											className="form-control Dark-Input-from-group"
											required
											accept=".pdf, .doc, .docx"
											ref={fileInputRef}
											onChange={(e) => {
												const file = e.target.files[0];
												if (file) {
													setResumeFile(file);
												}
											}}
										/>
										{display && !resumeFile ? (
											<span className="error_msg_lbl">
												Select resume {" "}
											</span>
										) : null}
									</div>

								</Col> */}
								<Col md={6}>
									<div className="post-form-group post-form-group-mob">
										<label>
											Upload resume : <span className="text-red">*</span>
											<span className="text-red f-500 ms-2">Can upload only 5MB file</span>
										</label>
										<input
											type="file"
											id="resumeUpload"
											className="form-control Dark-Input-from-group"
											required
											accept=".pdf, .doc, .docx"
											ref={fileInputRef}
											onChange={(e) => {
												const file = e.target.files[0];
												if (file) {
													if (file.size > 5 * 1024 * 1024) {
														// Show error if file exceeds 5MB
														setResumeFile(null);
														setResumeError("Select resume only 5MB");
													} else {
														setResumeFile(file);
														setResumeError(""); // clear any previous error
													}
												}
											}}
										/>
										{/* {display && !resumeFile ? (
											<span className="error_msg_lbl">Select resume</span>
										) : null} */}
										{resumeError && (
											<span className="error_msg_lbl">{resumeError}</span>
										)}
									</div>
								</Col>

								<Col md={6}>
									<div className="post-form-group mb-3">
										<label>
											LinkedIn profile :
										</label>
										<input
											type="text"
											placeholder="linkedin profile"
											value={linkedInProfile}
											onChange={(e) => setLinkedInProfile(e.target.value)}
											id="email"
											name="email"
											className="Normal-Input-Fill"
										/>
									</div>
								</Col>
							</Row>

							<div className="form-row">

								<div className="post-form-group mt-2">
									<label>
										Why do you want to work with People Labs? <span className="text-red">*</span>
									</label>
									<textarea
										type="text"
										placeholder="Type here"
										value={Reason}
										onChange={(e) => setReason(e.target.value)}
										id="email"
										name="email"
										className="normalinput-fill-border Normal-Input-Fill"
									/>
									{display && !Reason ? (
										<span className="error_msg_lbl">
											Enter reason{" "}
										</span>
									) : null}
								</div>
							</div>

							<div className="d-flex justify-content-center mt-3">
								<Button
									onClick={uploadResume}
									className="mainBtn apply-job "
								>
									Upload
								</Button>
							</div>

						</div>
					</section>
				</div>
			</div>
		</section>
	);
}

export default Reviewworkwitus;
